<template>
    <div class="live-page">
      <h3>Blockchain Live</h3>
      <div v-if="transactionsForView.length" class="transactions">
        <div class="one-transaction" v-for="item in transactionsForView" :key="item.id">
            <div class="time">{{moment(item.timestamp * 1000).utc().format('HH:mm:ss')}}</div>
            <div class="amount text-right">{{addCommas(item.amount)}}</div>
            <div class="coin">
                <cryptoicon :symbol="item.token" size="16" />
                <span>{{item.token}}</span>
            </div>
            <div class="amount_usd text-right">({{addCommas(item.amount_usd)}} USD)</div>
            <div class="text">
                transfered from
                <span class="wallet" v-if="item.from_owner">{{item.from_owner}}</span>
                <span v-else>unknown wallet</span>
                to 
                <span class="wallet" v-if="item.to_owner">{{item.to_owner}}</span>
                <span v-else>unknown wallet</span>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
export default {
  name: 'BlockchainLive',
  components: {
  
  },
  data: () => ({
    allTransactions:[]
  }),
  computed:{
      transactionsForView(){
          // show max 16 rows
          return this.allTransactions.slice(0,16);
      }
  },
  methods:{
      // get initial data
      getData(){
        const queryParameters = {
          params:{
            startDate:  moment(new Date().toUTCString()).utc().format('YYYY-MM-DD'),
            endDate:  moment(new Date().toUTCString()).utc().format('YYYY-MM-DD'),
            sort_by: 'timestamp',
            sort_order: 'DESC',
            page: 1,
          }
        };
        axios.get('tx/query',queryParameters).then(response => {
            this.allTransactions = response.data.slice(0, 10)
        });
      },
      connectToWebSocket(){
        this.$connect();
        this.$socket.onopen = () =>{
            this.$socket.onmessage = (message) =>{
                this.allTransactions.unshift(JSON.parse(message.data));
            }
        }
      }
  },
  created(){
    this.getData();
    this.connectToWebSocket();
  }
};
</script>
<style lang="scss" scoped>
.live-page{
    .transactions{
        background: var(--input-bg-color);
        border: 1px solid var(--input-br-color);
        border-radius: 4px;
        padding: 13px 21px;
        .one-transaction{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding: 4px 0px;
            &:not(:last-child){
                border-bottom: 1px solid var(--live-separator-color);
            }
            & > *{
                margin-right: 8px;
            }
            .time{
                font-size: 14px;
                line-height: 21px;
                color: #8D8BE1;
                width: 80px;
                @media (max-width: 500px) {
                    width: 100%;
                }
                &:before{
                    content: '';
                    width: 13px;
                    height: 13px;
                    display: inline-block;
                    background: url('../../assets/img/clock.svg') no-repeat;
                    margin-right: 5px;
                }
            }
            .amount{
                font-weight: 600;
                font-size: 14px;
                color: var(--live-amount-color);
                width: 85px;
                @media (max-width: 500px) {
                    width: auto;
                }
            }
            .coin{
                width: 70px;
                margin-right: 0;
                svg{
                    margin-right: 8px;
                    position: relative;
                    top: 3px;
                }
                span{
                    text-transform: uppercase;
                    font-size: 14px;
                    color: var(--live-amount-color);
                }
            }
            .amount_usd{
                font-size: 14px;
                color: #00BB56;
                width: 130px;
                @media (max-width: 500px) {
                    width: auto;
                }
            }
            .text{
                font-size: 14px;
                color: var(--live-text-color);
                @media (max-width: 900px) {
                    width: 100%;
                }
                span{
                    color: var(--live-text-color);
                }
                .wallet{
                    color: var(--live-wallet-color);
                    font-weight: bold;
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>